export default {"src":"/_next/static/media/chevron-right.3ab798e3.svg","height":13,"width":12};